import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { arrayOf, bool, shape } from "prop-types";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import CustomData from "pages/_components/CustomData/CustomData";
import Drawer from "pages/_components/Drawer/Drawer";
import TaxpayerItem from "./components/TaxpayerItem";
import DeleteTaxpayerForm from "./components/DeleteTaxpayerForm";

const Taxpayers = ({ isDesktop, fetching, taxpayersList, hasMoreData }) => {
    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    const [openSideForm, setOpenSideForm] = useState(false);
    const [taxpayerToDelete, setTaxpayerToDelete] = useState(null);
    const [fetchingMoreData, setFetchingMoreData] = useState(false);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.listTaxpayer(pageNumber));
    }, []);

    useEffect(() => {
        if (fetching && (taxpayersList.length === 0 || hasMoreData)) {
            setFetchingMoreData(true);
        } else {
            setFetchingMoreData(false);
        }
    }, [fetching]);

    const fetchMoreTransactions = () => {
        dispatch(afipPaymentLinkActions.listTaxpayer(pageNumber + 1));
        setPageNumber(pageNumber + 1);
    };

    const handleDeleteTaxpayer = (taxpayer) => {
        setTaxpayerToDelete(taxpayer);
        setOpenSideForm(true);
    };

    const onClose = () => {
        setOpenSideForm(false);
    };

    return (
        <>
            <div className="container py-8">
                {taxpayersList.length > 0 ? (
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetchingMoreData}
                        items={taxpayersList || []}
                        noDataText="vep.taxpayers.list.empty"
                        noFiltersDataText="vep.taxpayers.list.empty"
                        renderItem={(item, idx) => (
                            <GridTable.Container
                                columns={isDesktop ? 4 : 1}
                                rows={isDesktop ? 2 : 1}
                                key={`taxpayer-item-${idx}`}
                                renderAs="div">
                                <TaxpayerItem
                                    taxpayer={item}
                                    isDesktop={isDesktop}
                                    handleDelete={() => handleDeleteTaxpayer(item)}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="taxpayers-list text-neutral">
                                {listItem}
                                {hasMoreData && (
                                    <Button
                                        bsStyle="link"
                                        onClick={() => fetchMoreTransactions()}
                                        image="images/figma/icon/arrow.svg"
                                        label="global.showMore"
                                    />
                                )}
                            </GridTable>
                        )}
                    </ProductList>
                ) : (
                    <div className="box info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="vep.taxpayers.list.empty"
                            titleTextType="I18N"
                        />
                    </div>
                )}
            </div>
            <Drawer
                openSidebar={openSideForm}
                onClose={onClose}
                isFullHeight={!isDesktop}
                enableCloseButton={!!isDesktop}>
                <DeleteTaxpayerForm
                    isDesktop={isDesktop}
                    handleClose={onClose}
                    openForm={openSideForm}
                    taxpayer={taxpayerToDelete}
                />
            </Drawer>
        </>
    );
};

Taxpayers.propTypes = {
    isDesktop: bool.isRequired,
    fetching: bool.isRequired,
    taxpayersList: arrayOf(shape({})).isRequired,
    hasMoreData: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
    taxpayersList: afipPaymentLinkSelectors.getTaxpayersList(state),
    hasMoreData: afipPaymentLinkSelectors.getHasMoreData(state),
});

export default connect(mapStateToProps)(Taxpayers);
